import { Component, OnInit, forwardRef } from "@angular/core";
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NavController, NavParams, ModalController, ToastController, IonicModule } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { PessoaMigrarGruposPage } from "../pessoa-migrar-grupos/pessoa-migrar-grupos.page";
import { ConfigProvider } from "src/app/services/config/config";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { format } from "date-fns";
import { CommonModule } from "@angular/common";
import { ImagePipe } from "src/app/pipes/image/image";
import { switchMap } from "rxjs";
import { ProverDatepickerComponent } from "src/app/components/prover-datepicker/prover-datepicker";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { PessoaMigrarModalPage } from "../pessoa-migrar-modal/pessoa-migrar-modal.page";
interface Carteirinhas {
    id: number,
    dataVencimento: string,
    nome: string,
    idTipo: number,
    pessoa: string,
    instituicao: string,
    idInstituicao: number,
    idCarteirinhaTipoMembro: number,
    disable?: boolean,
    selected?: boolean
}

@Component({
  selector: "app-pessoa-migrar",
  templateUrl: "./pessoa-migrar.page.html",
  styleUrls: ["./pessoa-migrar.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    ReactiveFormsModule,
    ProverDatepickerComponent,
    LoadingSpinnerComponent,
  ],
})
export class PessoaMigrarPage implements OnInit {
  pessoa: any = {};
  validations_form: FormGroup;
  tipoList: any = [];
  subTipoList: any = [];
  historicoList: any = [];
  cargoList: any = [];
  grupos: any = [];
  tipoSelecionado: any = {};
  mostrarGrupo = false;
  criarHistorico = false;
  dados: any = {};
  isVisitanteGrupos = false;
  selectBadgeGrupos: any = [];
  loaded: boolean = false;
  submit = false;
  carteirinhas: Carteirinhas[] = [];
  selectBadgeCarteirinhas: any = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public translate: TranslateService,
    public pessoaProvider: PessoaProvider,
    public configProvider: ConfigProvider,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController
  ) {
    this.pessoa = this.navParams.get("pessoa");
    this.isVisitanteGrupos = this.navParams.get("isVisitante");
    this.initializeForm();

    this.pessoaProvider.getPessoaFuncao().subscribe((data) => {
      this.cargoList = data;
    });

    this.pessoaProvider.getTipoPessoa().subscribe((data) => {
      this.tipoList = data;
    });

    this.pessoaProvider.getTipoOcorrencia().subscribe((data) => {
      this.historicoList = data;
    });

    if (this.isVisitanteGrupos) {
      this.loadMigrationDataVisitante();
    }
    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  ngOnInit() {}

  historico() {
    if (this.criarHistorico) {
      this.validations_form.get("historico")?.setValidators([Validators.required]);
      this.validations_form.get("dataHistorico")?.setValidators([Validators.required]);
      this.validations_form.controls["historico"].updateValueAndValidity();
      this.validations_form.controls["dataHistorico"].updateValueAndValidity();
    } else {
      this.validations_form.get("historico")?.setValidators([]);
      this.validations_form.get("dataHistorico")?.setValidators([]);
      this.validations_form.controls["historico"].updateValueAndValidity();
      this.validations_form.controls["dataHistorico"].updateValueAndValidity();
    }
  }

  mudarTipo(tipo: any) {
    this.pessoaProvider.getSubtipoPessoa(tipo.detail.value).subscribe((data) => {
      this.subTipoList = data;

      if (this.pessoa.idPessoaTipo == 5 && tipo.detail.value != 5) {
        this.mostrarGrupo = true;
        this.initializeGrupos();
      } else if (this.pessoa.idPessoaTipo != 5 && tipo.detail.value == 5) {
        this.mostrarGrupo = true;
        this.initializeGrupos();
      } else {
        this.mostrarGrupo = false;
      }
      this.getCarteirinhas(this.pessoa.id);

      if (this.subTipoList.length) {
        this.validations_form.get("subtipo")?.setValue(null);
        this.validations_form.get("subtipo")?.clearValidators();
        this.validations_form.get("subtipo")?.setValidators([Validators.required]);
        this.validations_form.controls["subtipo"].updateValueAndValidity();
      }

      this.tipoList.forEach((element: { id: any }) => {
        if (element.id == tipo.detail.value) {
          this.tipoSelecionado = element;
        }
      });
    });
  }

  async selecionarGrupo() {
    let dados = {
      gruposSelect: this.grupos,
      isVisitante: this.isVisitanteGrupos,
    };

    var modalGrupos = await this.modalCtrl.create({
      component: PessoaMigrarGruposPage,
      componentProps: dados,
    });
    modalGrupos.present();

    const data = await modalGrupos.onWillDismiss();
    if (data.data) {
      this.grupos = data.data;
      this.selectBadgeGrupos = [];

      this.grupos.forEach((selectGrupos: { selected: boolean; idGrupo: any }) => {
        if (selectGrupos.selected) {
          this.selectBadgeGrupos.push({ idGrupo: selectGrupos.idGrupo });
        }
      });
    }
  }

  async selecionarCarteirinha() {
    let dados = {
      dataSelect: this.carteirinhas,
      nomeModal: 'Carteirinhas'
    };

    const modalCarteirinhas = await this.modalCtrl.create({
      component: PessoaMigrarModalPage,
      componentProps: dados,
    });

    modalCarteirinhas.present();
    const data = await modalCarteirinhas.onWillDismiss();

    if (data.data) {
      this.carteirinhas = data.data;
      this.selectBadgeCarteirinhas = [];

      this.grupos.forEach((selectCarteirinhas: { selected: boolean; idCarteirinha: any }) => {
        if (selectCarteirinhas.selected) {
          this.selectBadgeCarteirinhas.push({ idCarteirinha: selectCarteirinhas.idCarteirinha });
        }
      });
    }
  }

  initializeGrupos() {
    this.pessoaProvider.migrarGrupos(this.pessoa.id, this.pessoa.idPessoaTipo).subscribe((data) => {
      if (!this.grupos.length) {
        this.grupos = data;
        this.selectBadgeGrupos = data;

        this.grupos.forEach((element: { selected: boolean }) => {
          element.selected = true;
        });
      }
    });
  }

  getCarteirinhas(idPessoa: number) {
    this.pessoaProvider.getCarteirinhas(idPessoa).subscribe((data) => {
      this.carteirinhas = data;
    });
  }

  onSubmit(migracao: any) {
    this.submit = true;
    const forms = this.isVisitanteGrupos
      ? this.createMigrationObjectForVisitante(migracao)
      : this.createMigrationObjectForOther(migracao);
    this.pessoaProvider.migrarCadastro(forms).subscribe((data) => {
      if(!data) {
        this.toastAlert(data.message, data);
        this.submit = false;
      }else {
        this.toastAlert(this.translate.instant('Migrado com sucesso'), data);
      }     
    });
  }

  private createMigrationObject(migracao: any, isVisitanteGrupos: boolean): any {
    let mig: any = {};
    mig.finalizado = "1";
    mig.tipoMigracao = "tipo";
    mig.pessoa = { id: this.pessoa.id };
    mig.grupos = this.grupos;
    this.carteirinhas.forEach(carteirinha => {
      if (!carteirinha.disable && !('selected' in carteirinha)) {
        carteirinha.selected = true;
      }
    });

    mig.carteirinhas = this.carteirinhas;
    mig.idNovoTipo = isVisitanteGrupos ? this.dados.idTipo : migracao.tipo;
    mig.novoTipoMembro = isVisitanteGrupos ? this.dados.idSubTipo : migracao.subtipo;
    mig.infoAdicional = {
      cod1: null,
      cod2: null,
    };

    mig.funcao = {
      idPessoaFuncaoEspec: migracao.cargo,
      dataInicio: migracao.dataCargo,
    };

    if (migracao.criarHistorico) {
      mig.dataHistorico = isVisitanteGrupos ? format(new Date(), "yyyy-MM-dd") : migracao.dataHistorico;
      mig.anotacao = migracao.observacaoHistorico;
      mig.historico = isVisitanteGrupos ? this.dados.ocorrencia.id : migracao.historico;
    }

    return mig;
  }

  private createMigrationObjectForVisitante(migracao: any) {
    return this.createMigrationObject(migracao, true);
  }

  private createMigrationObjectForOther(migracao: any) {
    return this.createMigrationObject(migracao, false);
  }

  async toastAlert(message: string, data: any) {
    const toast = await this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: "bottom",
    });

    toast.present();

    this.modalCtrl.dismiss(data);
  }

  initializeForm() {
    this.validations_form = this.formBuilder.group({
      tipo: new FormControl("", Validators.required),
      subtipo: new FormControl(""),
      dataHistorico: new FormControl(format(new Date(), "yyyy-MM-dd")),
      cargo: new FormControl(""),
      dataCargo: new FormControl(format(new Date(), "yyyy-MM-dd")),
      historico: new FormControl(""),
      observacaoHistorico: new FormControl(""),
      criarHistorico: new FormControl(false),
    });
  }

  private loadMigrationDataVisitante() {
    this.pessoaProvider
      .buscarMigracaoConfiguracao()
      .pipe(
        switchMap((data: any) => {
          this.dados = data;
          this.setupInitialFormValues();
          if (this.dados.idTipo == 3) {
            this.tipoSelecionado = { id: this.dados.idTipo };
          }

          this.getCarteirinhas(this.pessoa.id);
          return this.pessoaProvider.getSubtipoPessoa(this.dados.idTipo);
        })
      )
      .subscribe(
        (subtipoData) => {
          this.handleSubtipoData(subtipoData);
        },
        (error) => {
          console.error("Erro ao carregar dados de migração:", error);
        }
      );
  }

  setupInitialFormValues() {
    this.mostrarGrupo = true;
    this.criarHistorico = true;

    this.validations_form.get("dataHistorico")?.disable();
    this.validations_form.get("tipo")?.disable();
    this.validations_form.get("subtipo")?.disable();
    this.validations_form.get("historico")?.disable();
    this.validations_form.get("dataHistorico")?.setValue(format(new Date(), "yyyy-MM-dd"));
    this.validations_form.get("tipo")?.setValue(Number(this.dados.idTipo));
    this.validations_form.get("historico")?.setValue(Number(this.dados.ocorrencia.id));
    this.validations_form.get("criarHistorico")?.setValue(true);
    this.initializeGrupos();
  }

  handleSubtipoData(subtipoData: any) {
    this.subTipoList = subtipoData;
    this.validations_form.get("subtipo")?.setValue(Number(this.dados.idSubTipo));
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  validation_messages = {
    tipo: [
      {
        type: "required",
        message: this.translate.instant("O tipo deve ser informado"),
      },
    ],
    subtipo: [
      {
        type: "required",
        message: this.translate.instant("O subtipo deve ser informado"),
      },
    ],
    dataHistorico: [
      {
        type: "required",
        message: this.translate.instant("A data deve ser informada"),
      },
    ],
    historico: [
      {
        type: "required",
        message: this.translate.instant("O histórico deve ser informado"),
      },
    ],
    dataCargo: [
      {
        type: "required",
        message: this.translate.instant("A data deve ser informada"),
      },
    ],
    cargo: [
      {
        type: "required",
        message: this.translate.instant("O cargo deve ser informado"),
      },
    ],
  };

  get dataLabel(): string {
    const prefixo = this.translate.instant("Data");
    const sufixo = this.isVisitanteGrupos
      ? this.translate.instant("da Ocorrência")
      : this.translate.instant("do Histórico");
    return `${prefixo} ${sufixo}`;
  }
}
